import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import Loading from 'custom/assets/loaders/Loading'
import BeneficiaryTransferService from '../../../../services/beneficiary-transfers.service'
import DashboardService from '../../../../services/dashboard.service'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import InputError from '../../../../components/InputError/InputError'
import { Formik, Form } from 'formik'
import LayoutWithOutAccountCard from '../../../../layout/Layout/layout-without-card'
import AccountsService from '../../../../services/accounts.service'
import {
  SIDENAV_KEYS,
  MENU_SIDEBAR_KEYS,
  LANDING_KEYS,
  VALIDATION_MESSAGES,
} from '../../../../utils/translation-constants'
import Download from 'custom/assets/icons/download.svg'

export default function MT103() {
  // const history = useHistory()
  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [loadingDownload, setLoadingDownload] = useState(false)
  const [stage, setStage] = useState(0)
  const [refList, setRefList] = useState([])
  const [isAccSelected, setIsAccSelected] = useState(false)
  const [accountList, setAccountList] = useState([])
  const [formValues, setFormValues] = useState({})
  const [accounts, setAccounts] = useState([])

  useEffect(() => {
    fetchAccounts()
  }, [])

  const fetchAccounts = useCallback(async () => {
    try {
      const response = await AccountsService.getAllAccounts()
      if (response.status === 200) {
        const casaAccountList = response.data['accountSummaryDetails']
        setAccounts(casaAccountList)
        setStage(1)
      }
    } catch (err) {
      setStage(1)
    }
  }, [])

  const getDownload = useCallback(
    async (selected) => {
      try {
        setLoadingDownload(true)
        const reqParams = {
          ...selected,
          ...formValues,
        }
        await BeneficiaryTransferService.downLoadMT103Report(reqParams)
        // setStage(1)
        setLoadingDownload(false)
      } catch (err) {
        setLoadingDownload(false)
      }
    },
    [formValues],
  )

  const getAllRefNumbers = useCallback(async (values) => {
    setLoading(true)
    setRefList([])
    setFormValues(values)
    try {
      const response = await DashboardService.GetMT103RefNumbers(values)
      if (response.status === 200) {
        setIsAccSelected(true)
        setLoading(false)
        setRefList(response.data['contractRef'])
      }
    } catch (err) {
      setIsAccSelected(false)
      setLoading(false)
    }
  })
  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderReceiptsViewForm()
      default:
        return renderReceiptsViewForm()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReceiptsViewForm() {
    return (
      <div>
        <Formik
          initialValues={{
            accountNumber: '',
          }}
          onSubmit={getAllRefNumbers}
          validationSchema={Yup.object().shape({
            accountNumber: Yup.string().required(t(VALIDATION_MESSAGES.ACCUNT_NO_REQUIRED)),
          })}>
          {({ isSubmitting, errors, touched, handleChange }) => (
            <Form>
              <div className='form-group my-4'>
                <NeoInput
                  mode='select'
                  text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.ACCOUNTNO)}
                  name='accountNumber'
                  onChange={handleChange}
                  list={accounts}
                  keyValue='accountNo'
                />
                <InputError text={errors.accountNumber} touched={touched.accountNumber} />
              </div>
              <div className='mt-3'>
                {loading ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    disabled={loadingDownload}
                    type='submit'
                    text={t(SIDENAV_KEYS.SETTINGS_KEYS.CHANGE_PASSWORD_KEYS.SUBMIT)}
                    mode='newDesign'
                  />
                )}
              </div>
            </Form>
          )}
        </Formik>

        {refList === null && <p style={{ textAlign: 'center', marginTop: 20 }}>{t(LANDING_KEYS.NO_RECORD)}</p>}

        {refList !== null && refList.length > 0 && (
          <>
            <div>
              <div className='heading6'>
                <div className='reference-number'>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REFERENCE_NUMBER)}</div>
                <div className='reference-number'></div>
              </div>
              {refList.map((item, index) => (
                <div className='reference-number-row mb-3' key={index}>
                  <div className='reference-number-col'>{item.contractRefNo}</div>
                  <div className='reference-number-col'>
                    <img
                      disabled={loadingDownload}
                      src={Download}
                      alt='download'
                      onClick={() => getDownload(item)}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className='mt-3'>{loadingDownload && renderLoading()}</div>
          </>
        )}
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='BENE_MT103' showEmptySpace={true} keyPath={'MT103'}>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.MT103)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}
